// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CoinVerticalBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M19 2.5h-6C8.234 2.5 4.5 8.43 4.5 16S8.234 29.5 13 29.5h6c4.766 0 8.5-5.93 8.5-13.5S23.766 2.5 19 2.5Zm4.651 19H20.79c.353-1.308.574-2.648.661-4h2.991a16.651 16.651 0 0 1-.79 4Zm-2.201-7a20.328 20.328 0 0 0-.661-4h2.862c.426 1.296.692 2.64.79 4H21.45Zm.704-7h-2.5a12.277 12.277 0 0 0-1.25-2H19c.671 0 1.906.281 3.154 2ZM9.346 23.73C8.155 21.689 7.5 18.944 7.5 16c0-2.944.655-5.689 1.846-7.73C10.75 5.86 12.24 5.5 13 5.5c.761 0 2.25.36 3.654 2.77C17.845 10.311 18.5 13.056 18.5 16c0 2.944-.655 5.689-1.846 7.73C15.25 26.14 13.76 26.5 13 26.5c-.761 0-2.25-.36-3.654-2.77ZM19 26.5h-.599a12.29 12.29 0 0 0 1.25-2h2.5c-1.245 1.719-2.48 2-3.151 2Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
